import { useAtomValue } from "jotai";
import { useEffect } from "react";
import {
  participantSidsAtom,
  roomAtom,
  roomToDiagnosticInfo,
  useStoredAudioVideoSettings,
} from "../video-sdk";
import { logger, setLoggerGlobalContext } from "./logger";

/**
 * Sets application-specific DataDog global context for logging i.e. all logs
 * will have this information. This should help debug with
 * application/user-specific context.
 *
 * You can add info to he global context as desired, but take care to not add
 * PHI/PII.
 */
export function useInitGlobalDDLoggerContext(
  additionalContext: Record<string, unknown> = {},
) {
  const room = useAtomValue(roomAtom);
  const remoteParticipantSids = useAtomValue(participantSidsAtom);
  const storedAudioVideoSettings =
    useStoredAudioVideoSettings()?.storedAudioVideoSettings;

  useEffect(
    function setGlobalLoggerDDContext() {
      (async () => {
        try {
          setLoggerGlobalContext({
            storedAudioVideoSettings: storedAudioVideoSettings,
            ...(room
              ? {
                  twilio: roomToDiagnosticInfo(room),
                }
              : {}),
            remoteParticipantSids,
            ...additionalContext,
          });
        } catch (error) {
          logger.error(
            "Unable to set global logger context",
            {},
            error as Error,
          );
        }
      })();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [remoteParticipantSids, storedAudioVideoSettings, room],
  );
}
